import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import styles from './YesNoModal.module.css';
import Button from '../button/Button';

export default function YesNoModalComponent({
  closeModal,
  confirmModal,
  yesButtonText,
  noButtonText,
  showModal,
  header,
  description,
  isLoading,
}) {
  return (
    <Modal show={showModal} centered size="md">
      <div className={styles.body} style={{ textAlign: 'center' }}>
        <div>
          <p className={styles.confirmationText}>{header}</p>

          <p className={styles.description}>{description}</p>
        </div>

        <div className={`${styles.marginTop30}`}>
          <Button
            style={{
              backgroundColor: 'transparent',
              border: 'none',
              color: '#6d6d73',
            }}
            text={noButtonText}
            onClick={closeModal}
          />
          <Button
            text={yesButtonText}
            onClick={confirmModal}
            style={{
              marginLeft: '10px',
            }}
            isLoading={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
}
YesNoModalComponent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  confirmModal: PropTypes.func.isRequired,
  yesButtonText: PropTypes.string,
  noButtonText: PropTypes.string,
  showModal: PropTypes.bool,
  header: PropTypes.string,
  description: PropTypes.string,
  isLoading: PropTypes.bool,
};
YesNoModalComponent.defaultProps = {
  yesButtonText: 'Confirm',
  noButtonText: 'Cancel',
  showModal: false,
  isLoading: false,
};
